import { render, staticRenderFns } from "./ConceptPaymentList.vue?vue&type=template&id=5fac45a0&"
import script from "./ConceptPaymentList.vue?vue&type=script&lang=js&"
export * from "./ConceptPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports